module.exports = __webpack_public_path__ + "static/media/icon-coin.ebea99e6.svg";